import { m } from 'framer-motion';
import { useLocation } from 'react-router-dom';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { Box, LinearProgress } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// config
import { NAV } from '../../config-global';
// auth
import { useAuthContext } from '../../auth/useAuthContext';
//
import Logo from '../logo';
import ProgressBar from '../progress-bar';
import { useSettingsContext } from '../settings';
import LoadingProgressBar from '../../sections/common/progressbarpopup';


// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  right: 0,
  bottom: 0,
  zIndex: 9998,
  width: '100%',
  height: '100%',
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------


export default function LoadingScreen() {
    const { pathname } = useLocation();

    const isDesktop = useResponsive('up', 'lg');

    const { isInitialized } = useAuthContext();

    const { themeLayout } = useSettingsContext();

    const isDashboard = isInitialized && pathname.includes('/dashboard') && isDesktop;

    const size =
        (themeLayout === 'mini' && NAV.W_DASHBOARD_MINI) ||
        (themeLayout === 'vertical' && NAV.W_DASHBOARD) ||
        128;

    return (
        <>
            <ProgressBar />
            <LoadingProgressBar msg="  " disabledLink sx={{ width: 64, height: 64 }} />

        </>
    );
}
